<div class="">
  <div class="main-container">
  <div class="main-content">
    <!-- Document Type Cards -->
     
    <div class="list-header">
      <button class="back-btn" (click)="goBack()">
        <i class="fas fa-chevron-left"></i>
      </button>
      <!-- <h2 *ngIf="medicationData.length === 0">Medications</h2>
      <h2 *ngIf="medicationData.length> 0">List Of Medications</h2> -->
            
      <h2>Medications</h2>
    </div>

    <!-- Document List Section -->
    <div class="document-list">
      <div class="search-section" *ngIf="medicationData.length> 0">
        <div class="search-container">
          <i class="material-icons">search</i>
          <input class="search-text" type="text" [(ngModel)] =searchText placeholder="Search for medication...">
        </div>
      </div>

      <h2 class="listMed" *ngIf="medicationData.length> 0">List Of Medications ( {{medicationData.length}} )</h2>

      <!-- Display Documents -->
      <ng-container *ngIf="medicationData.length > 0; else emptyState">
            <div class="medication-grid" >
            <div class="medication-card" *ngFor="let med of filteredMedication">
              
              <div class="card-header">
                <div class="med-icon"><img class="imghel" src="assets/images/health/homeimg/Pills.svg"/></div>
                <div class="med-title-group medTitle">
                  <h3 class="med-name">{{ med.medicationName }}</h3>
                  <p class="med-info">
                    {{ med.strength }} {{ med.unit }} 
                  </p>
                </div>
                <div class="card-actions" style="margin-top: -20px;">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onEdit(med)">
                      <!-- <mat-icon>edit</mat-icon> -->
                      <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                      <span>Edit</span>
                    </button>
                    <button mat-menu-item (click)="onDelete(med)">
                      <!-- <mat-icon>delete</mat-icon> -->
                      <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </div>

              <!-- <div class="med-condition">Condition: <strong>{{ med.medCondition }}</strong></div> -->
              <!-- <div class="med-date-range">
                From {{ med.startDate }} to {{ med.endDate || 'Ongoing' }}
              </div> -->

              <!-- <div class="med-timings" *ngIf="med.frequency === 'everyDay'">
                <label>Timings:</label>
                <ul>
                  <li *ngFor="let t of med.timeFrequency">
                    <span class="dot"></span> {{ t.time }} — {{ t.dosage }} dose
                  </li>
                </ul>
              </div> -->
              <div class="card-footer" *ngIf="med.frequency === 'everyDay'" >
                <div class="next-dose"  >
                   {{ getNextDoseTime(med) }}
                </div>

              </div>
              <div class="card-footer"  class="asNeeded" *ngIf="med.frequency != 'everyDay'" >
                   <mat-icon>repeat</mat-icon><span>As Needed</span>
              </div>
                
           

           </div>

         </div>
         
      </ng-container>
        <!-- <ng-template #emptyState>
            <div class="empty-state">
            <img src="assets/images/empty-state.png" alt="No Medications" />
            <p>No medications found. Please add some.</p>
            </div>
        </ng-template> -->

          <!-- Empty State -->
          <!-- <ng-template #emptyState>
          <div class="empty-state">
            <img class="noimg" src="assets/images/medicine.png"/>
            <h3>No Medications Added Yet..</h3>
            <p>Add new medications to keep track of your health records</p>
            <button class="add-new-btn" mat-raised-button (click)="openDialog()">
              <span class="btn-text"> + Add Medication</span>
            </button>
          </div>
          </ng-template> -->

          <ng-template #emptyState>
            <div class="empty-state-card">
              <!-- Log Img -->
              <img class="empty-icon" src="assets/images/health/homeimg/RedPills.svg" alt="Icon"/>
               <!-- Log Title -->
               <h3>Set up Medication</h3>

              <!-- Logs Div -->
              <!-- medication -->
              <div class="empty-description">
                <div class="desc-item">
                  <img src="assets/images/medicine.png" alt="Track" />
                  <span class="trackTxt">Track all your medication</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/icons/data medis.svg" alt="Check" />
                  <span class="trackTxt">Set a schedule and be reminded</span>
                </div>
              </div>
              <!-- Logs Div ends here -->

              <!-- Log Button -->
              <button class="add-new-btn" mat-raised-button (click)="openDialog()">
                Add Medication
              </button>
              <!-- Log Button -->
            </div>
          </ng-template>
   
    </div>
  </div>

    <button class="fab-button" (click)="openDialog()" *ngIf="medicationData.length> 0">
        <img src="assets/images/health/icons/dtopico/Frame 1000006692.svg" class="dd-icon" alt="User Icon" />
    </button>

</div>
</div>